















import Vue from 'vue'
import { Component, Mixin, Lifecycle, Prop, p } from 'av-ts'
import { EventBus } from '@/eventbus'
import { ILesson } from '@/models'

@Component()
export default class Lesson extends Mixin(EventBus) {
  @Prop id = p({
    type: String,
    required: true
  })
  lesson: ILesson | undefined = undefined

  @Lifecycle
  async created() {
    console.debug('[Lesson.vue] created store=', this.$store)
    console.debug('  lesson id =', this.id)
    // load lesson
    this.lesson = await this.$store.getLesson(this.id)
  }  
}
